import { Stack } from '@mui/material'
import { Icon } from '@mxenabled/mx-icons'
import { InstitutionLogo } from '@mxenabled/mxui'
import { IconBacking } from '../../../../common'
import { getLayoutConfig } from './layout'
import { useTheme } from '@mui/material/styles'
import type { InsightsInstanceSlotData } from '../../../../core/types/InsightsInstanceSlotData'

interface IconComponentProps {
  blockData: InsightsInstanceSlotData
  variant: string | null
}

export const IconComponent = ({ blockData, variant }: IconComponentProps) => {
  const theme = useTheme()
  const layoutConfig = getLayoutConfig(theme)[variant as keyof ReturnType<typeof getLayoutConfig>]

  if (blockData.institution_guid) {
    return (
      <Stack sx={{ alignItems: 'center', flexDirection: 'row', position: 'relative' }}>
        <InstitutionLogo
          alt={`${blockData.institution_name}`}
          institutionGuid={`${blockData.institution_guid}`}
          size={48}
        />
        <IconBacking size={20} sx={{ position: 'absolute', right: -8, top: -8 }}>
          <Icon
            color="error"
            fill={true}
            name="error"
            size={20}
            sx={{ gridColumn: 1, gridRow: 1, zIndex: 2 }}
          />
        </IconBacking>
      </Stack>
    )
  }

  if (blockData.icon_name) {
    return (
      <Stack
        sx={{
          alignItems: 'center',
          bgcolor: layoutConfig.logo_bGcolor,
          borderRadius: '6px',
          height: 48,
          justifyContent: 'center',
          width: 48,
          ...(layoutConfig.logo_border_color && {
            borderColor: layoutConfig.logo_border_color,
            borderStyle: 'solid',
            borderWidth: 1.5,
          }),
        }}
      >
        <Icon
          name={blockData.icon_name}
          size={24}
          sx={{
            color: layoutConfig.logo_color,
          }}
        />
      </Stack>
    )
  }

  return null
}
